import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useDarkMode from "../../hooks/useDarkMode";
import { login, requestOtp } from "../../redux/auth/actions";
import { useAppDispatch } from "../../hooks/hooks";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import storePersist from "../../redux/storePersist";
import _ from "lodash";
import { getAccountTypeChannalName } from "../../common/services/common.service";
import { selectChannelListItems } from "../../redux/channel/selector";
import { userProfile } from "../../redux/userProfile/action";
import { toast } from "react-toastify";
import useWindowDimensions from "../../hooks/useWindowsDimensions";
import PageLoader from "../../components/PageLoader";
import EmailInput from "../../common/components/form/EmailInput.Component";
import PasswordInput from "../../common/components/form/PasswordInput.Component";
import { RotatingLines } from "react-loader-spinner";
import UserInput from "../../common/components/form/UserInput.component";

export default function CandidateLogin() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const channelListItem = useSelector(selectChannelListItems)
    const { register, handleSubmit, clearErrors, formState: { errors }, setValue } = useForm();
    const [loginValues, setLoginValues] = useState<any>()
    const [isLoginWithOTP, setIsLoginWithOTP] = React.useState(false)
    const [isOtpChecked, setIsOtpChecked] = useState(false);
    const [isRequestOtp, setIsRequestOtp] = useState(false);
    const [colorTheme, setTheme] = useDarkMode();
    const [steps, setSteps] = useState({ Email: '', Password: '' })
    const [darkSide, setDarkSide] = useState(
        colorTheme === "light" ? true : false
    );
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [baseURL, setBaseUrl] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const { height, width } = useWindowDimensions();
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };
    const toggleDarkMode = (checked: any) => {
        setTheme(colorTheme);
        setDarkSide(checked);
    };

    const handleChange: any = (event: any, field: string) => {
        setLoginValues({ ...loginValues, [field]: event })
    }

    const handleRegistration = () => {
        navigate('/candidate/register')
    };
    const startGoogleAuthentication = () => {
        storePersist.set('google-login-role', 'candidate')
        const token = localStorage.getItem("guest-token");
        const url = `https://identity.digiit.${process.env.REACT_APP_API_URL}/googleauth/SignInWithGoogle?guest_token=${token}&ClientRedirectUrl=${baseURL}`
        window.location.href = url;
    }
    const handleSteps = (e: any, key: any) => {
        setSteps({ ...steps, [key]: e.target.value })
    }
    const gotoHome = (role: any) => {
        switch (role?.toLocaleLowerCase()) {
            case 'candidate':
                navigate('/candidate/home')
                break;
            default:
                navigate('/auth/login/candidate')
        }
    }

    const handleForgotPassword = (e: any) => {
        e.preventDefault();
        storePersist.set('reset-pwd', 'candidate')
        navigate('/auth/login/forgot-password')
    }

    const onFinish = async () => {
        await setIsLoading(true)
        if (isRequestOtp) {
            try {
                await dispatch(requestOtp({
                    loginData: {
                        Username: steps?.Email
                    }
                }))
                setIsOtpChecked(false)
                setIsLoginWithOTP(true)
            } catch (e: any) {
                toast.error('There was an error in login. Please try again...')
                console.error('Login failed:', e);
            }
            await setIsLoading(false)
        } else {
            try {
                   const metaData: any = storePersist.get("metaTokenMetaData");
                
                const token = await dispatch(login({
                    loginData: {
                        "Records": [
                            {
                                "Context": {
                                    "Subscription": "ONE",
                                "Domain": "ONE",
                                "SubDomains": [],
                                "Network": "Candidate",
                                "Application": "Candidate",
                                "Channel": "CSP"
                                },
                                "Message": {
                                    "Username": steps?.Email,
                                    "Password": steps?.Password,
                                    "AccountType": "Candidate",
                                    "LoginWithOtp": isLoginWithOTP,
                                    "Otp": loginValues?.otp || '',
                                    "IsGoogleAuthenticated": false,
                                    "AuthenticatedUserId": "",
                                    "ClientIPAddress": "",
                                    "OrganizationUnitId": metaData?.current?.items?.Website?.OUId
                                }
                            }
                        ]
                    }
                }))

                try {
                    const resp: any = await dispatch(userProfile.read({ url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/iam/user-service/user-profile/me`, entity: 'userProfile', options: { notifyOnSuccess: false, notifyOnFailed: false } }));
                    let selectedRole = ''
                    const targetRoles = ['candidate']; // Roles to match
                    resp.find((element: any) =>
                        element?.Message?.Roles.find((role: any) => {
                            if (targetRoles.includes(role?.Name?.toLowerCase())) {
                                selectedRole = role.Name.toLowerCase();
                                return true;
                            }
                            return false;
                        })
                    );
                    await gotoHome(selectedRole);
                    await setIsLoading(false)
                } catch (e: any) {
                    console.error('Login failed:', e);
                    await setIsLoading(false)
                }
            } catch (e: any) {
                // toast.error('There was an error in login. Please try again...')
                console.error('Login failed:', e?.Error?.Message);
                await setIsLoading(false)
            }
        }
    };

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" })
        setBaseUrl(window.location.origin);
        clearErrors('Email')
        clearErrors('Password')
    }, [])

    return (
        <>

            <form onSubmit={handleSubmit(onFinish)} >
                {(width && width < 724) ? <>
                    <div className="w-screen h-screen bg-white px-6 flex items-center justify-center sm:hidden">
                        <div className="w-full max-w-sm bg-white shadow-lg rounded-lg p-6">
                            <h2 className="text-2xl font-semibold text-center">Candidate User Log In</h2>
                            <div className="flex justify-center my-2">
                                <svg width="172" height="29" viewBox="0 0 172 29" fill="none" xmlns="http://www.w3.org/2000/svg" className="mx-auto mb-5">
                                    <path d="M1 5.08742C17.6667 19.0972 30.5 31.1305 62.5 27.2693C110.617 21.4634 150 -10.09 171 5.08727" stroke="#FFBB38"></path>
                                </svg>
                            </div>
                            <div className="space-y-5">
                                {/* Email Input */}
                                <UserInput
                                    label="Email Address / Phone Number"
                                    name="Email"
                                    isRequired={true}
                                    register={register}
                                    errors={errors}
                                    setValue={setValue}
                                    handleSteps={(e) => handleSteps(e, 'Email')}
                                />
                                {/* OTP or Password Login */}
                                {!isLoginWithOTP && (
                                    <div className="flex items-center my-3">
                                        <label className="text-gray-500 mr-2">Login With OTP:</label>
                                        <input
                                            id="otp"
                                            type="checkbox"
                                            className="w-4 h-4 border-gray-300 rounded focus:ring-primary-300"
                                            onChange={(e) => setIsOtpChecked(e.target.checked)}
                                        />
                                    </div>
                                )}

                                {isLoginWithOTP && !isOtpChecked && (
                                    <input
                                        className="w-full p-2.5 text-gray-900 rounded-lg border focus:ring-primary-600 focus:border-primary-600"
                                        type="number"
                                        placeholder="Enter OTP"
                                        {...register('otp', { required: `OTP is required` })}
                                        onChange={(event) => handleChange(event.target.value, 'otp')}
                                        value={loginValues?.otp}
                                    />
                                )}

                                {!isLoginWithOTP && !isOtpChecked && (
                                    <PasswordInput
                                        label="Password"
                                        name="Password"
                                        isRequired={true}
                                        register={register}
                                        errors={errors}
                                        setValue={setValue}
                                        handleSteps={(e) => handleSteps(e, 'Password')}
                                    />
                                )}
                            </div>
                            {/* Remember Me & Forgot Password */}
                            <div className="flex justify-between items-center my-4">
                                <label className="flex items-center cursor-pointer">
                                    <input type="checkbox" className="form-checkbox" />
                                    <span className="ml-2 text-md text-black">Remember me</span>
                                </label>
                                <a href="#" onClick={handleForgotPassword} className="text-yellow-500 text-md">Forgot password?</a>
                            </div>

                            {/* Submit Button */}
                            <div className="mt-6">
                                {isOtpChecked && !isLoginWithOTP ? (
                                    <button
                                        type="submit"
                                        disabled={isLoading}
                                        onClick={() => setIsRequestOtp(true)}
                                        className={`w-full text-white flex items-center justify-center font-semibold py-2 rounded ${isLoading ? 'bg-primary bg-opacity-70' : 'bg-primary'}`}
                                    >
                                        Request OTP
                                        <div className={` ${isLoading ? 'visible pl-2' : 'invisible'}`}>
                                            <RotatingLines
                                                visible={true}
                                                width={'20'}
                                                strokeColor="#fff"
                                                strokeWidth="6"
                                                animationDuration="0.75"
                                                ariaLabel="rotating-lines-loading"
                                            />
                                        </div>
                                    </button>
                                ) : (
                                    <button
                                        type="submit"
                                        disabled={isLoading}
                                        onClick={() => setIsRequestOtp(false)}
                                        className={`w-full text-white flex items-center justify-center font-semibold py-2 rounded ${isLoading ? 'bg-primary bg-opacity-70' : 'bg-primary'}`}
                                    >
                                        Login
                                        <div className={` ${isLoading ? 'visible pl-2' : 'invisible'}`}>
                                            <RotatingLines
                                                visible={true}
                                                width={'20'}
                                                strokeColor="#fff"
                                                strokeWidth="6"
                                                animationDuration="0.75"
                                                ariaLabel="rotating-lines-loading"
                                            />
                                        </div>
                                    </button>
                                )}
                            </div>
                            {/* Google Sign-in */}
                            <div className="flex items-center justify-center mt-4 bg-gray-100 py-2 rounded-lg">
                                <img src={require('../../assets/img/google.jpeg')} alt="Google Sign In" className="h-6 w-6 mr-2" />
                                <button type="button" className="text-black text-opacity-50 text-lg" onClick={startGoogleAuthentication}>
                                    Sign In with Google
                                </button>
                            </div>
                            {/* Sign Up Link */}
                            <div className="text-center text-black text-opacity-50 mt-3">
                                Don't have an account?
                                <a onClick={handleRegistration} className="text-black font-medium cursor-pointer"> Sign Up Free</a>
                            </div>
                        </div>
                    </div>
                </> :
                    <div className="flex max-h-screen bg-[#F8F8F8]">
                        <div className="container  mx-auto px-4 flex flex-col lg:flex-row items-center justify-between">
                            {/* Left Side - Form Section */}
                            <div className="w-full lg:w-1/2  flex justify-center">
                                <div className="w-full  bg-white p-6 h-[550px]">
                                    <div className="text-center">
                                        <h2 className="text-3xl font-bold">Candidate User Log In</h2>
                                        <div className="flex justify-center mt-2">
                                            <svg width="120" height="20" viewBox="0 0 172 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M1 5.08742C17.6667 19.0972 30.5 31.1305 62.5 27.2693C110.617 21.4634 150 -10.09 171 5.08727" stroke="#FFBB38"></path>
                                            </svg>
                                        </div>
                                    </div>

                                    {/* Email Input */}
                                    <div className="mt-6">
                                        <UserInput
                                            label="Email Address / Phone Number"
                                            name="Email"
                                            isRequired={true}
                                            register={register}
                                            errors={errors}
                                            setValue={setValue}
                                            handleSteps={(e) => handleSteps(e, 'Email')}
                                        />
                                    </div>

                                    {/* OTP or Password Login */}
                                    {!isLoginWithOTP && (
                                        <div className="mt-4 flex items-center">
                                            <label className="text-gray-600 text-sm">Login With OTP:</label>
                                            <input
                                                id="otp"
                                                type="checkbox"
                                                className="ml-2 w-4 h-4 rounded border-gray-300 focus:ring-primary-300"
                                                onChange={(e) => setIsOtpChecked(e.target.checked)}
                                            />
                                        </div>
                                    )}

                                    {isLoginWithOTP && !isOtpChecked && (
                                        <div className="mt-4">
                                            <input
                                                className="w-full p-2 border rounded focus:ring-primary-500 focus:border-primary-500"
                                                type="number"
                                                placeholder="Enter OTP"
                                                {...register('otp', { required: `OTP is required` })}
                                                onChange={(event) => handleChange(event.target.value, 'otp')}
                                                value={loginValues?.otp}
                                            />
                                        </div>
                                    )}

                                    {!isLoginWithOTP && !isOtpChecked && (
                                        <div className="mt-4">
                                            <PasswordInput
                                                label="Password"
                                                name="Password"
                                                isRequired={true}
                                                register={register}
                                                errors={errors}
                                                setValue={setValue}
                                                handleSteps={(e) => handleSteps(e, 'Password')}
                                            />
                                        </div>
                                    )}

                                    {/* Remember Me & Forgot Password */}
                                    <div className="flex justify-between items-center text-sm mt-4">
                                        <label className="flex items-center space-x-2">
                                            <input type="checkbox" className="form-checkbox" />
                                            <span>Remember me</span>
                                        </label>
                                        <a href="#" onClick={(e) => handleForgotPassword(e)} className="text-yellow-500">
                                            Forgot password?
                                        </a>
                                    </div>

                                    {/* Submit Button */}
                                    <div className="mt-6">
                                        {isOtpChecked && !isLoginWithOTP ? (
                                            <button
                                                type="submit"
                                                disabled={isLoading}
                                                onClick={() => setIsRequestOtp(true)}
                                                className={`w-full h-11 flex items-center justify-center text-white rounded-lg text-lg font-semibold ${isLoading ? 'bg-opacity-70 bg-primary' : 'bg-primary'}`}
                                            >
                                                Request OTP
                                                <div className={` ${isLoading ? 'visible pl-2' : 'invisible'}`}>
                                                    <RotatingLines
                                                        visible={true}
                                                        width={'20'}
                                                        strokeColor="#fff"
                                                        strokeWidth="6"
                                                        animationDuration="0.75"
                                                        ariaLabel="rotating-lines-loading"
                                                    />
                                                </div>
                                            </button>
                                        ) : (
                                            <button
                                                type="submit"
                                                disabled={isLoading}
                                                onClick={() => setIsRequestOtp(false)}
                                                className={`w-full h-11 flex items-center justify-center text-white rounded-lg text-lg font-semibold ${isLoading ? 'bg-opacity-70 bg-primary' : 'bg-primary'}`}
                                            >
                                                Login
                                                <div className={` ${isLoading ? 'visible pl-2' : 'invisible'}`}>
                                                    <RotatingLines
                                                        visible={true}
                                                        width={'20'}
                                                        strokeColor="#fff"
                                                        strokeWidth="6"
                                                        animationDuration="0.75"
                                                        ariaLabel="rotating-lines-loading"
                                                    />
                                                </div>
                                            </button>
                                        )}
                                    </div>

                                    {/* Google Sign-in */}
                                    <div className="flex items-center justify-center space-x-2 mt-6 bg-gray-100 p-3 rounded-lg">
                                        <img src={require('./../../assets/img/google.jpeg')} className="h-5 w-5" />
                                        <button className="text-sm text-gray-600" onClick={() => startGoogleAuthentication()}>
                                            Sign In with Google
                                        </button>
                                    </div>

                                    {/* Sign Up Link */}
                                    <div className="text-center text-sm text-gray-600 mt-4">
                                        Don't have an account?
                                        <span onClick={() => handleRegistration()} className="text-black font-medium cursor-pointer"> Sign Up Free</span>
                                    </div>
                                </div>
                            </div>

                            {/* Right Side */}
                            <div className="hidden lg:flex w-1/2 justify-center">
                                <img src={require('../../assets/img/logisticsLogin.png')} className="max-w-lg" alt="Login Illustration" />
                            </div>
                        </div>
                    </div>

                }

            </form >
        </>
    );
}
